/**
 * Format the chat response to handle markdown-like formatting
 * 
 * @param {string} text - The text to format
 * @returns {string} - The formatted HTML
 */
export const formatResponse = (text) => {
  if (!text) return '';
  
  // Replace line breaks with <br> tags
  let formattedText = text.replace(/\n/g, '<br>');
  
  // Format bold text: **text** or __text__ to <strong>text</strong>
  formattedText = formattedText.replace(/(\*\*|__)(.*?)\1/g, '<strong>$2</strong>');
  
  // Format italic text: *text* or _text_ to <em>text</em>
  formattedText = formattedText.replace(/(\*|_)(.*?)\1/g, '<em>$2</em>');
  
  // Format code blocks with ```
  formattedText = formattedText.replace(/```([\s\S]*?)```/g, '<pre><code>$1</code></pre>');
  
  // Format inline code with `
  formattedText = formattedText.replace(/`([^`]+)`/g, '<code>$1</code>');
  
  // Format lists
  formattedText = formattedText.replace(/^\s*[\-*+]\s+(.*?)(?=<br>|$)/gm, '<li>$1</li>');
  
  // Special handling for BetFI Presale website - add a badge
  formattedText = formattedText.replace(
    /(https:\/\/dev-sales\.betfi365\.com\/)/g, 
    '<a href="$1" target="_blank" class="betfi-badge"><span class="betfi-icon">🚀</span> BetFI Presale <span class="betfi-arrow">→</span></a>'
  );
  
  // Return sanitized HTML
  return formattedText;
};

/**
 * Get SVG path for an icon by name
 * 
 * @param {string} iconName - The name of the icon
 * @returns {string} - The SVG path data
 */
export const getIconPath = (iconName) => {
  switch(iconName) {
    case 'message-square':
      return 'path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"';
    case 'brain':
      return 'path d="M9.5 2h5M4.5 10h15M4.5 18h15M9.5 22h5M12 2v20M2 12a3.5 3.5 0 0 0 7 0a3.5 3.5 0 0 0-7 0M15 12a3.5 3.5 0 1 0 7 0a3.5 3.5 0 1 0-7 0M2 7.5v9M22 7.5v9"';
    case 'trending-up':
      return 'polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/><polyline points="17 6 23 6 23 12"/';
    case 'headphones':
      return 'path d="M3 18v-6a9 9 0 0 1 18 0v6"/><path d="M21 19a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3zM3 19a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H3z"/';
    case 'message-circle':
      return 'path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"/';
    case 'edit-2':
      return 'path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"/';
    case 'zap':
      return 'polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/';
    default:
      return '';
  }
};
